const uriProd = "https://fascon-api.appgw.telin.tw";
const uriTest = "https://fascon-api-test.appgw.telin.tw";

export const URL = ["fascon.telin.tw", "fascon-panel.netlify.app"].includes(
  window.location.host
)
  ? uriProd
  : uriTest;
